import React, { useState } from 'react';
import { Item, OwnerItem } from '@/types/item';
import { t } from 'i18next';
import bgItem from '@/assets/images/pngs/item-location.png';
import addLocationIcon from '@/assets/images/pngs/add-location.png';
import { ITEMS_CONST } from '@/configs/constants';

interface ListProps {
    className?: string,
    items: OwnerItem[],
    handleAddLocation: Function
}

const ItemLocationList: React.FC<ListProps> = ({ className = '', items, handleAddLocation }) => {
    return (
        <div className={`  ${className} space-y-[12px]`}>
            {items && items.map(item => (
                <div key={item.id} className='flex items-center bg-white shadow-md w-full h-[124px] rounded-[4px] relative'>
                    <img src={bgItem} alt={bgItem} className='w-full h-full rounded-[4px]' />
                    <div className='w-[100px] h-[100px] absolute top-[12px] left-[12px] rounded-[4px]'>
                        <img loading='lazy' src={item.file?.path} alt={item.file?.filename} className='w-[100px] h-[100px] object-cover' />
                    </div>
                    {item.itemType === ITEMS_CONST.ITEM_TYPE.COUPON && (
                        <div className='absolute top-[12px] right-[12px] bg-gradient-to-r from-[#EA4335] to-[#F47843] text-white text-xs px-[12px] py-[2px] rounded'>
                            {t('text.coupon')}
                        </div>
                    )}
                    {item.address ?
                        (
                            <div className='absolute left-[124px] w-[calc(100vw-160px)]'>
                                <p className='text-gray font-bold text-[15px] truncate'>{item.item}</p>
                                <span className=' text-[13px] text-textGreen break-words line-clamp-2'>{item.address}</span>
                            </div>
                        ) :
                        (
                            <div className='absolute left-[124px] w-[calc(100vw-160px)]'>
                                <p className=' font-bold text-[15px] truncate '>{item.item}</p>
                                <button onClick={() => handleAddLocation(item)} className='flex '>
                                    <img src={addLocationIcon} alt={addLocationIcon} className='w-4 h-4' />
                                    <span className=' font-light text-[13px] text-textBlue ml-1'>{t('text.addLocation')}</span>
                                </button>
                            </div>
                        )}
                </div>
            ))}
        </div>
    );
};

export default ItemLocationList;
